import { render, staticRenderFns } from "./VariationImageSelector.vue?vue&type=template&id=22d386ec&scoped=true"
import script from "./VariationImageSelector.vue?vue&type=script&lang=js"
export * from "./VariationImageSelector.vue?vue&type=script&lang=js"
import style0 from "./VariationImageSelector.vue?vue&type=style&index=0&id=22d386ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d386ec",
  null
  
)

export default component.exports